/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 933
// module chunks = 2